import { katTranslator } from '../../shared/i18n';

const strings = {
  "kat_button_group_overflow_trigger_label": {
    "en-US": "Show more",
    "ar-AE": "عرض المزيد",
    "bn-IN": "আরও দেখান",
    "de-DE": "Mehr anzeigen",
    "es-ES": "Más información",
    "es-MX": "Mostrar más",
    "fr-BE": "Afficher plus",
    "fr-FR": "Afficher plus",
    "gu-IN": "વધુ બતાવો",
    "hi-IN": "और दिखाएं",
    "it-IT": "Mostra altro",
    "ja-JP": "さらに表示",
    "kn-IN": "ಇನ್ನಷ್ಟು ತೋರಿಸಿ",
    "ko-KR": "자세히 표시",
    "ml-IN": "കൂടുതൽ കാണിക്കുക",
    "mr-IN": "आणखी दाखवा",
    "nl-BE": "Meer weergeven",
    "nl-NL": "Meer weergeven",
    "pl-PL": "Pokaż więcej",
    "pt-BR": "Mostrar mais",
    "pt-PT": "Mostrar mais",
    "sv-SE": "Visa mer",
    "ta-IN": "மேலும் காட்டு",
    "te-IN": "మరిన్ని చూపించండి",
    "th-TH": "แสดงเพิ่มเติม",
    "tr-TR": "Daha fazla göster",
    "vi-VN": "Hiện thêm",
    "zh-CN": "显示更多",
    "zh-TW": "顯示更多"
  }
}; 

export default katTranslator(strings);
    